import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from "react-dom";
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Notification from 'rc-notification';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import SubscriberShowData from './SubscriberShowData';
import { getSubscribersData, handleLoader } from '../../../../redux/actions/SubscribersAction';
import { months, } from '../../CompareMonth/helper';
import { setCurrencyFormat, findMonthsBetweenDates } from '../../../../utils/helpers';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import { sortType } from '../../helper'

const Subscribers = ({ dispatch, rtl }) => {
  const { t } = useTranslation('common');
  const location = useLocation();
  const navigate = useNavigate();

  const currentYear = moment().format('YYYY');
  const prevYear = currentYear - 1;
  const currentMonth = moment().format('MMM');
  const prevMonth = moment().subtract(11, 'months').format('MMM');

  const { subscribersData, salesChannelFilterData, isLoading } = useSelector(
    ({ subscribersReducer, marketPlaceReducer }) =>
    ({
      subscribersData: subscribersReducer.subscribersData,
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      isLoading: subscribersReducer.isLoading
    })
  );
  const [dataToShow, setDataToShow] = useState(subscribersData?.modal?.data?.[0]?.yearlySubscription);
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [maxValueObj, setMaxValueObj] = useState({})
  const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth })
  const [month1, setMonth1] = useState({ year: prevYear, month: prevMonth });
  const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
  const [tempMonth1, setTempMonth1] = useState({ year: prevYear, month: prevMonth });
  const [selectedCountryOptions, setSelectedCountryOptions] = useState();

  const countryCodeOptions = [];
  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const monthOptions = months.map(item => ({ label: item, value: item }));

  const date1 = `${month1?.year}-${month1?.month}`;
  const date2 = `${month2?.year}-${month2?.month}`;

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  // eslint-disable-next-line array-callback-return
  subscribersData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
    data.filterData.forEach((element) => {
      countryCodeOptions.push({
        value: element.key === "SP" ? "ES" : element.key,
        label: element.shortValue
      });
    });
  });

  const sortedCountryOptions = countryCodeOptions.sort((a, b) => a.label > b.label ? 1 : -1)
  // eslint-disable-next-line react/prop-types
  const changeFilterForCountry = (value) => {
    setSelectedCountryOptions(value)
  };

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    
    const dvChartV = document.getElementById('dvChartView');   
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Subscribers Report ${new Date().getFullYear()}`,
    })    
    dvChartV.style.display = "block"; 
  }

  const handleApplyDate = () => {
    const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
    const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

    const monthsBetween = findMonthsBetweenDates(startDate, endDate);
    //  if (monthsBetween?.length > 0 && monthsBetween?.length <= 12) {
    setMonth1(tempMonth1);
    setMonth2(tempMonth2);
    setMaxValueObj({})
    dispatch(handleLoader(true));
    dispatch(getSubscribersData());
    // } else {
    //     Notification.newInstance({}, (notification) => {
    //         notification.notice({
    //             content: 'Please select maximum one year data'
    //         });
    //     });
    // }
  }

  const handleYearMonthChange = ({ isFrom, field, value }) => {

    if (isFrom) {
      setTempMonth1({ ...tempMonth1, [field]: value?.value });
    } else {
      setTempMonth2({ ...tempMonth2, [field]: value?.value })
    }
  }

  const setMaxValue = useCallback((val) => {
    if (!maxValueObj[val]) {
      setMaxValueObj({ ...maxValueObj, [val]: Number(val) })
    }
  }, [maxValueObj])

  const getMonths = (start, end) =>
    Array.from({ length: end.diff(start, 'month') + 1 }).map((_, index) =>
      moment(start).add(index, 'month').format('MMM-YYYY'));

  const selectedFromMonth = month1.month;
  const selectedFromYear = month1.year;
  const selectedToMonth = month2.month;
  const selectedToYear = month2.year;

  const selectFromDate = selectedFromMonth + selectedFromYear;
  const selectToDate = selectedToMonth + selectedToYear;

  const selectedMonths = getMonths(moment(selectFromDate, 'MMMYYYY'), moment(selectToDate, 'MMMYYYY'))

  // eslint-disable-next-line react/prop-types
  const RenderYearAndMonth = ({ isFrom }) => (
    <Col sm="12" md="4">
      <Row className="justify-content-space-between">
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Year</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                  : { value: tempMonth2?.year, label: tempMonth2?.year }}
                options={yearOptions}
                clearable={false}
                placeholder="Select Year"
                className="select_filter-110"
                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'from' : 'to'}
              />
            </div>

          </div>
        </Col>
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Month</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                  : { value: tempMonth2?.month, label: tempMonth2?.month }}
                options={monthOptions}
                clearable={false}
                placeholder="Select Month"
                className="select_filter-110"
                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'fromMonth' : 'toMonth'}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );

  useEffect(() => {
    dispatch(handleLoader(true));
    dispatch(getSubscribersData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(subscribersData?.modal?.data?.[0]?.yearlySubscription);
  }, [subscribersData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  let dataToShowForDatesSelected = [];

  const monthsBetweenDates = findMonthsBetweenDates(date1, date2);
  for (let i = 0; i < monthsBetweenDates.length; i += 1) {
    const [year, month] = monthsBetweenDates?.[i]?.split('-');
    let monthWiseData = dataToShow?.[year]?.monthlySubscriptioin?.[month] ?? [];
    if (monthWiseData) {
      monthWiseData = monthWiseData.filter(item =>
        filterBasedOnFilter(item))?.map(item => ({
          ...item,
          salesMonth: month,
          salesYear: year
        }))
      dataToShowForDatesSelected = dataToShowForDatesSelected?.concat(monthWiseData);

    }
  }
  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
        disabled={!dataToShowForDatesSelected.length}
      >
        View Report
      </button>
    </div>
  )

  if (selectedCountryOptions?.length) {
    const selected = selectedCountryOptions?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    dataToShowForDatesSelected = dataToShowForDatesSelected.filter(item => selected[item.coutryCode])
  }

  const thisMonthData = {};

  dataToShowForDatesSelected.forEach((item) => {

    if (item.yearMonth && thisMonthData[item.yearMonth]) {
      thisMonthData[item.yearMonth].push(item)
    } else {
      thisMonthData[item.yearMonth] = [item]
    }

  })

  const reduceCallback = (acc, item) => acc + Number(item.noOfSubscriptions)
  const dataToPlot = []

  Object.keys((thisMonthData)).forEach((monthYear) => {
    const [year, month] = monthYear.split('-');
    const yearMonthStr = moment(monthYear).format('YYYY-MMM')
    const totalNoOfSubscriptions = thisMonthData?.[monthYear].reduce(reduceCallback, 0)
    dataToPlot.push({
      "date": yearMonthStr,
      'noOfSubscriptions': totalNoOfSubscriptions.toFixed(0),
    })
  });

  const dataToShowForExcel = [];
  const tableHeader = [
    {
      Header: "Date",
      accessor: "date",
      disableGlobalFilter: false,
      width: 120,
      sortType
    },
    {
      Header: "Subscriptions",
      accessor: "noOfSubscriptions",
      disableGlobalFilter: false,
      width: 120,
      rightAlign: true,
      sortType
    }
  ];

  dataToPlot?.forEach((dataValue, index) => {
    const subData = {}
    subData.date = dataValue?.date;
    subData.noOfSubscriptions = setCurrencyFormat(dataValue?.noOfSubscriptions, false);
    dataToShowForExcel.push(subData)
  });

  const uploadExcel = () => {
    console.log('')
    navigate('/upload/subscriber', { state: { countryOption: sortedCountryOptions } })
  }

  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">Subscribers</h5>
              </div>
              <Row className="justify-content-space-between align-items-center pb-0">
                <Col sm="6" md="2">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Country</span>
                    <div className="form__form-group-field">
                      <Select
                        value={selectedCountryOptions}
                        options={sortedCountryOptions}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter"
                        onChange={changeFilterForCountry}
                        classNamePrefix="react-select"
                        isMulti
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="12" md="10">
                  <Row className="justify-content-right align-items-center ">
                    <RenderYearAndMonth isFrom />
                    <Col sm='1' className="filter-to-position">~</Col>
                    <RenderYearAndMonth />
                    <Col sm="3" className="p-0 filter-to-position">
                      <button className="btn btn-sm btn-primary
                                             apply-date-button"
                        type="button" onClick={handleApplyDate}>
                        Apply</button>
                        <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>  
                                          
                    </Col>                    
                  </Row>                
                  
                </Col>
              </Row>
              <Row className="justify-content-end align-items-center">                    
                <Col sm="12" className="p-0 filter-to-position text-end">                       
                  <button 
                    id='btnProductDownload' 
                    className="btn btn-sm btn-primary" 
                    style={{ color: 'white', marginRight: '38px' }} 
                    onClick={uploadExcel}
                  >
                    Upload Excel
                  </button>                     
                </Col>                    
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div id="divToPrint" ref={container}>
      <Card className="pb-3">
        <CardBody className="">
          <div className="top-location"
            style={{ minHeight: '400' }}>
            <div >
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                : <SubscriberShowData
                  title="Subscribers"
                  viewReportButton={viewReportButton}
                  data={dataToShowForDatesSelected}
                  dir={rtl.direction}
                />}
            </div>
          </div>
        </CardBody>
      </Card>
      </div>
      <ViewSalesReportModal
        modalData={dataToShowForExcel}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
      />
    </Container>
  );
};

Subscribers.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(Subscribers);